<template>
  <v-card style="margin: 0; padding: 0;">
    <v-card-title primary-title style="margin: 0;padding: 0 5px">
      <v-subheader>动态属性</v-subheader>
      <!-- <gh-prop-view :model="model" :prop="PropDic.type"></gh-prop-view> -->
    </v-card-title>
    <component :is="type" :model="model" :props="props"></component>
  </v-card>
</template>

<style scoped>

</style>

<script>
  import DynamicProperty from "./dynamicProperty.ts";
  export default DynamicProperty;
</script>